/**
 * @siteone/gitlab-ci-deploy
 */
import { deploy } from './deploy/deploy'
import { pm2DeployStart, pm2DeployBefore, pm2OnStop, pm2DeployAfter, pm2Revert, getRevertState } from './deploy/pm2/pm2'
import { deployUpload, deployUploadFiles } from './deploy/upload'
import { healthCheck } from './deploy/healthCheck'
import { getCurrentEnvironment, getCurrentEnvironmentConfig } from './deploy/environments/deployEnvironment'
import { setupDynamicArgs } from './deploy/environments/setupDynamicArgs'
import { exec } from './util/exec'
import { sendMessage } from './mattermost/mattermost'
import { createTag, parseTag } from './util/tagsHelpers'
import { getDeployConfiguration, getCiConfiguration } from './configuration/configuration'
import { createBaseConfig, defaultBuildTemplate, defaultDeployTemplate, defaultStopTemplate, defaultRevertTemplate, defaultStages } from './gitlabCi/createGitlabCiConfig'

const defaultCiConfigFile = 'ci.config.js'
const defaultDeployConfigFile = 'deploy.config.js'

export {
  defaultDeployConfigFile,
  defaultCiConfigFile,
  getDeployConfiguration,
  getCiConfiguration,
  deploy,
  pm2DeployStart,
  pm2DeployBefore,
  pm2OnStop,
  pm2DeployAfter,
  pm2Revert,
  getRevertState,
  getCurrentEnvironment,
  getCurrentEnvironmentConfig,
  setupDynamicArgs,
  deployUpload,
  deployUploadFiles,
  healthCheck,
  exec,
  sendMessage,
  createTag,
  parseTag,
  createBaseConfig,
  defaultBuildTemplate,
  defaultDeployTemplate,
  defaultStopTemplate,
  defaultRevertTemplate,
  defaultStages
}

